import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconEditSvg } from './IconEditSvg';

export const IconEdit: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconEditSvg} {...iconProps} />;
};
